import { gql } from '@apollo/client';

export const getCleaningTaskCompletionList = gql`
  query getTaskCompletion($isoYear: Int, $isoMonth: Int, $isoWeek: Int) {
    getTaskCompletion(
      isoYear: $isoYear
      isoMonth: $isoMonth
      isoWeek: $isoWeek
    ) {
      isoYear
      isoMonth
      isoWeek
      completed
      interrupted
      stopped
    }
  }
`;
